import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { Dropdown, GhostButton, Header, useIcons } from '@steinpilz/react-ux/business-app';

import { LocalizationDropdown, useTranslation } from '@steinpilz/react-ux/i10n';

import { Path } from '@router/types';
import { useAuthenticatedUser } from '@infrastructure/authorization';
import { useConfirmIfDirty } from '@infrastructure/unsaved-changes/hooks/useConfirmIfDirty';
import { configuration } from '@configs/client';
import { UserButtonText } from './styled';

export const AppHeader: React.FC = () => {
  const navigate = useNavigate();
  const confirmIfDirty = useConfirmIfDirty();
  const handleBack = useCallback(() => confirmIfDirty(() => navigate(-1)), [confirmIfDirty]);
  const handleHome = useCallback(() => confirmIfDirty(() => navigate(Path.HOME)), [confirmIfDirty]);
  const Icons = useIcons();
  const authenticatedUser = useAuthenticatedUser();

  const t = useTranslation();
  const title = t('DamageDoc.Application.Title');

  const handleLogOut = useCallback(() => {
    window.location.href = configuration.logOutRedirectForWeb();
  }, []);

  return (
    <Header
      onBack={handleBack}
      onHome={handleHome}
      onAppName={handleHome}
      title={title}
      userMenu={{
        buttonContent: (
          <GhostButton>
            <UserButtonText>
              {authenticatedUser}
            </UserButtonText>
          </GhostButton>
        ),
        userName: authenticatedUser!,
        menuItems: [
          {
            label: t("DamageDoc.Header.Logout"),
            icon: <Icons.UserIcon />,
            onClick: handleLogOut,
          },
        ],
      }}
      rightSection={<LocalizationDropdown component={Dropdown} />}
    />
  );
};
